export default __webpack_public_path__ + "static/media/left-arrow-menu-button.2dce5d3f.svg";